export default __webpack_public_path__ + "static/blogs-img-2-92d9aa33568706e343d937f6eb31b42d.png";